<template lang="pug">
section.hero.is-fullheight.is-bold
    .container.is-fluid
        Navbar
    .container.is-fluid
        .passwordLogin(v-if="showPasswordLogin")
            p.title.is-1 Login
            .columns.is-centered
                .column.is-2
                    b-input(type="username", placeholder="Username", v-model="username", icon="user", rounded)
            .columns.is-centered
                .column.is-2
                    b-input(type="password", placeholder="Password", v-model="password", icon="lock", rounded)
            .columns.is-centered
                .column.is-2
                    b-button(type="is-link", @click="loginUser", rounded, expanded) Login
            .columns.is-centered
                .column.is-2
                    b-button(type="is-danger", @click="toggleLogin" rounded, expanded) Cancel
        .loginHome(v-else)
            .columns.is-centered
                .column.is-2
                    b-button(type="is-dark", @click="toggleLogin", rounded) Login with password
            .columns.is-centered
                .column.is-2
                    b-button(type="is-duke", @click="loginWithNetID", rounded) Login with NetID
</template>

<script>
import Navbar from "@/components/Navbar.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser, faLock } from "@fortawesome/free-solid-svg-icons";

library.add(faUser, faLock);

export default {
  name: "Login",
  title: "LM Dashboard",
  components: {
    Navbar
  },
  data: function() {
    return {
      showPasswordLogin: false,
      username: "",
      password: ""
    };
  },
  methods: {
    toggleLogin() {
      this.showPasswordLogin = !this.showPasswordLogin;
    },

    loginWithNetID() {
      console.log("login with netid");
    },

    loginUser() {
      // Get username and password from text input fields
      const usernameInput = this.username.toString();
      const passwordInput = this.password.toString();

      const userData = {
        username: usernameInput,
        password: passwordInput
      };

      // Dispatch Vuex action login
      this.$store
        .dispatch("login", userData)
        .then(() => {
          this.$router.push("/");
        })
        .catch(err => {
          if (err.response === undefined) {
            console.log(err);
            return;
          }

          const status = err.response.status;

          if (status === undefined) {
            console.log(err);
            return;
          }

          if (status === 401) {
            this.showWrongPassword();
          } else if (status === 404) {
            this.showUserNotFound();
          }
        });
    },

    showUserNotFound() {
      this.$buefy.dialog.alert({
        title: "User Not Found",
        message: "Make sure your username is correct!",
        type: "is-duke"
      });
    },

    showWrongPassword() {
      this.$buefy.dialog.alert({
        title: "Wrong Password",
        message: "Make sure your password is correct!",
        type: "is-duke"
      });
    }
  }
};
</script>

<style scoped lang="scss">
p.title {
  font-weight: 300;
}

p.subtitle {
  font-weight: 300;
}
</style>
